@if ((items?.length ?? 0) > 0) {
    <div class="list">
        @for (item of items; track $index; let i = $index) {
            <div class="item" [class.disabled]="item.cardinality === 0">
                <p-checkbox
                    role="checkbox"
                    [attr.aria-label]="item.term"
                    [attr.aria-checked]="item.state"
                    [ngModel]="item.state === true"
                    [indeterminate]="item.state === null"
                    (onChange)="onCheckboxChanged(item, $event)"
                    [binary]="true"
                    id="{{ listFacetSectionComponentId + '_' + i }}"
                >
                    <ng-template #icon let-checked="checked">
                        @if (checked) {
                            <span class="p-checkbox-icon pi pi-check"></span>
                        } @else if (item.state === false) {
                            <span class="p-checkbox-icon pi pi-times"></span>
                        }
                    </ng-template>
                </p-checkbox>
                <span
                    class="term"
                    [ngClass]="{ 'term-deselected': item.state === false }"
                    (mouseover)="setTooltip($event, item.term)"
                    >{{ item.term }}</span
                >
                @if (item.cardinality) {
                    <div class="cardinality">
                        <span>{{ item.cardinality }}</span>
                    </div>
                }
                @if (item.cardinality === 0) {
                    <span class="cardinality-zero">-</span>
                }
            </div>
        }
    </div>
}
